import { useEffect, useState } from "react";
import axios from "../../axios";
import { Link } from "react-router-dom";
import "./HomePage.css"; // kita buat style khusus
import formatCurrency from "../../utils/formatCurrency";
import { STORAGE_URL } from "../../constants";

export default function HomePage() {
    const [products, setProducts] = useState([]);
    const [banners, setBanners] = useState([]);
    const [faqs, setFaqs] = useState([]);
    const [settings, setSettings] = useState([]);

    useEffect(() => {
        const fetch = async () => {
            try {
                const res = await axios.get("/products"); // public endpoint
                setProducts(res.data.filter((p) => p.status === "active"));
            } catch (err) {
                console.error("Gagal memuat produk", err);
            }
        };
        fetch();

        const fetchBanner = async () => {
            try {
                const res = await axios.get("/banners"); // public endpoint
                const active = res.data.filter(b => b.is_active);
                setBanners(active);
            } catch (err) {
                console.error("Gagal memuat produk", err);
            }
        };

        fetchBanner();

        const fetchFaq = async () => {
            try {
                const res = await axios.get("/faqs"); // public endpoint
                const activeFaqs = res.data.filter(f => f.is_active == '1');
                setFaqs(activeFaqs);
            } catch (err) {
                console.error("Gagal memuat faq", err);
            }
        };

        fetchFaq();


        const fetchInfo = async () => {
            try {
                const res = await axios.get("/settings"); // public endpoint
                setSettings(res.data);
            } catch (err) {
                console.error("Gagal memuat faq", err);
            }
        };

        fetchInfo();
    }, []);


    return (
        <div className="mt-24">
            {/* <h2 className="text-center mb-4">Produk Album Foto</h2> */}
            <div className="home-banner ">
                <div className="carousel slide" id="bannerCarousel" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        {banners.map((b, i) => (
                            <div key={b.id} className={`carousel-item ${i === 0 ? "active" : ""}`}>
                                <img
                                    src={`${STORAGE_URL}${b.image}`}
                                    className="d-block w-100"
                                    alt="Banner"
                                    style={{ maxHeight: "600px", objectFit: "cover" }}
                                />
                                {b.title && (
                                    <div className="carousel-caption d-none d-md-block">
                                        <h5>{b.title}</h5>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                    <button className="carousel-control-prev" type="button" data-bs-target="#bannerCarousel" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" />
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#bannerCarousel" data-bs-slide="next">
                        <span className="carousel-control-next-icon" />
                    </button>
                </div>
            </div>

            <div className="my-24">
                <h3>Produk Kami</h3>
                <div className="row product-grid">
                    {products.map((p) => (
                        <div className="col-6 col-md-2 mb-3">
                            <div className="product-card" key={p.id}>
                                <div className="image-wrapper">
                                    {p.photos && p.photos.length > 0 ? (
                                        <img
                                            src={`${STORAGE_URL}${p.photos[0].file_path}`}
                                            alt={p.name}
                                        />
                                    ) : (
                                        <div className="no-image">Tidak ada gambar</div>
                                    )}
                                </div>
                                <div className="product-info">
                                    <h5>{p.name}</h5>
                                    <small>{p.category?.name} / {p.subcategory?.name}</small> <br />
                                    <small>Rp.{formatCurrency(parseInt(p?.category_price) + parseInt(p?.subcategory_price))}</small>
                                    <div className="flex-grow-1"></div>
                                    <div className="action">
                                        <Link to={`/product/${p.id}`} className="btn d-block" style={{ backgroundColor: '#a69778', color: '#fff' }} >
                                            Lihat Detail
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <h3>FAQ</h3>
            <div className="accordion" id="faqAccordion">
                {faqs.map((f, i) => (
                    <div className="accordion-item" key={f.id}>
                        <h2 className="accordion-header" id={`heading-${i}`}>
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse-${i}`}>
                                {f.question}
                            </button>
                        </h2>
                        <div id={`collapse-${i}`} className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                            <div className="accordion-body">{f.answer}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
